import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

interface CodeBlockProps {
  children: ReactNode;
  /** Height cap — long payloads scroll inside the block rather than the page. */
  maxHeightClassName?: string;
}

/**
 * Code / JSON payload inside an expanded {@link InvisibleRow}: tool inputs and
 * outputs, sandbox actions, system prompts, LLM records.
 *
 * These used to be bare `<pre>`s with slightly different classes at every site,
 * so a transcript with several open rows had no consistent treatment for "this
 * is machine output, not prose". One bordered grey block, mono type, scrolling
 * inside its own cap.
 *
 * Only rendered inside `ConversationTimeline`, which is studio-only, so the
 * design-system `body-mono` resolves here. Anything on the widget's render path
 * must stay on raw Tailwind.
 */
export function CodeBlock({ children, maxHeightClassName = "max-h-60" }: CodeBlockProps): React.ReactElement {
  return (
    <pre
      className={filterClasses(
        // `text-left` is explicit: the expanded area centres its prose, and
        // centred JSON is unreadable.
        "body-mono overflow-auto rounded-sm border border-grey-200 bg-grey-50 p-2 text-left whitespace-pre-wrap text-grey-700",
        maxHeightClassName
      )}
    >
      {children}
    </pre>
  );
}
